import * as React from 'react';
import { FormikProps } from 'formik';
import TextField from '@material-ui/core/TextField';
import { getErrorAndTouched, IField } from './utils';

interface IProps {
  field: IField;
  form: FormikProps<any>;
  label: string;
}

const FormikTextField = (props: IProps) => {
  const { field, form, label, ...other } = props;

  if (!field || !form) {
    return null;
  }

  const {
    touched,
    error
  }: { touched: boolean; error: string } = getErrorAndTouched(form, field);

  const handleChange = (event: any) => {
    field.onChange(event);
  };

  return (
    <TextField
      name={field.name}
      label={label}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      error={!!(touched && error)}
      helperText={!!touched && error}
      {...other}
    />
  );
};

export default FormikTextField;



// WEBPACK FOOTER //
// ./src/common/formik/formik-text-field.tsx